/* eslint-disable react/prop-types */
import React from 'react';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useHistory } from 'react-router';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

const useStyles = makeStyles((theme) => ({
  root: {},
  sectionWrapper: {
    padding: '30px 30px 30px 30px',
    backgroundColor: theme.palette.$lightGreyWhite,
    '@media (max-width: 767px)': {
      padding: '30px 10px',
    },
  },
  title: {
    fontSize: theme.typography.$fzH4,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    marginBottom: '30px',
    '@media (max-width: 767px)': {
      fontSize: theme.typography.$fzH5,
    },
  },
  isMb30: {
    marginBottom: '30px',
  },
  isMb20: {
    marginBottom: '20px',
  },
  isMb10: {
    marginBottom: '10px',
  },
  isMr10: {
    marginRight: '10px',
  },
  bR5: {
    borderRadius: '5px',
  },
  flexBtwSpace: {
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: 'flex-start',
  },
  btnBackSection: {
    fontSize: theme.typography.$fzH6,
    lineHeight: theme.typography.$fzH2,
    color: theme.palette.$clearBlue,
    alignItems: 'center',
    cursor: 'pointer',
  },
  iconEdit: {
    fontSize: theme.typography.$fzH5,
  },
}));

const SectionWrapper = ({
  title, children, isMb20, isMb10,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.sectionWrapper}>
      {title && (
        <div className={clsx(
          classes.title,
          classes.isMb30,
          isMb20 && classes.isMb20,
          isMb10 && classes.isMb10,
        )}
        >
          {title}
        </div>
      )}
      <div className={classes.content}>{children}</div>
    </div>
  );
};

SectionWrapper.defaultProps = {
  isMb20: false,
  isMb10: false,
};

SectionWrapper.propTypes = {
  title: PropTypes.node.isRequired,
  isMb20: PropTypes.bool,
  isMb10: PropTypes.bool,
};

export default SectionWrapper;

export const SectionWrapperReview = ({
  title, children, isMb20, isMb10, backToUrl, onClick,
}) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={clsx(classes.sectionWrapper, classes.bR5, classes.isMb10)}>
      <div className={clsx(classes.flexBtwSpace)}>
        <div className={clsx(
          classes.title,
          isMb20 && classes.isMb20,
          isMb10 && classes.isMb10,
        )}
        >
          {title}
        </div>
        <div
          className={clsx(classes.flexBtwSpace, classes.btnBackSection)}
          onClick={() => {
            onClick();
            history.push(backToUrl);
          }}
        >
          <EditOutlinedIcon className={clsx(classes.isMr10, classes.iconEdit)} />
          {' '}
          Edit
        </div>
      </div>

      <div className={classes.content}>{children}</div>
    </div>
  );
};

SectionWrapperReview.propTypes = {
  title: PropTypes.node.isRequired,
  isMb20: PropTypes.bool,
  isMb10: PropTypes.bool,
};